import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-checkmark-done-sharp",
  "use": "icon-checkmark-done-sharp-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-checkmark-done-sharp\"><title>Checkmark Done</title><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"44\" d=\"M465 127L241 384l-92-92M140 385l-93-93M363 127L236 273\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol